import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/hvac';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(purchaseNotifications[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setBuyer(purchaseNotifications[Math.floor(Math.random() * purchaseNotifications.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-146" data-mp="b3u1bt2nhz3r">
      {visible && <motion.div initial={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed right-3 top-3 z-50 w-[250px] sm:w-[270px]" role="status" aria-live="polite" data-id="element-147" data-mp="b2sfctk3js79">
          <div className="relative overflow-hidden rounded-lg border-2 border-cta bg-white p-2.5 pr-7 shadow-2xl" data-id="element-148" data-mp="286sfttiy6gmn">
            <span className="absolute inset-x-0 top-0 h-1 bg-diag" aria-hidden="true" data-id="element-149" data-mp="1bh1bl2kutf3n" />
            <button type="button" onClick={() => setVisible(false)} aria-label="Close notification" className="absolute right-1 top-1.5 text-charcoal/50 transition-colors duration-150 hover:text-navy" data-id="element-150" data-mp="1fgtqdx0uchhg">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-151" data-mp="rs0oljxjffex" />
            </button>
            <div className="flex items-center gap-2.5" data-id="element-152" data-mp="rq6dexc2j1o1">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cta/15 text-cta" data-id="element-153" data-mp="wpsrf8zq0lxw">
                <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-154" data-mp="200g9lbp700jq" />
              </span>
              <div className="leading-tight" data-id="element-155" data-mp="1v2etmzn2chch">
                <p className="text-[13px] font-extrabold text-navy" data-id="element-156" data-mp="28u36x691tbv1">{buyer.name}</p>
                <p className="text-[10px] font-semibold text-charcoal/70" data-id="element-157" data-mp="28w5wjp6ah2z8">
                  {buyer.location}
                </p>
                <p className="mt-0.5 text-[11px] font-bold text-cta" data-id="element-158" data-mp="1h2nc4oxc8itq">
                  just purchased HVAC DIAGNOSTIC READY™
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}